<template>
  <div class="presentation-container page-content">    
    <div class="w-100 px-5 py-2" style="background-color: #3281bc;">
      <img v-if="getApplicantType === 'Mercer'" src="../../../public/assets/images/mercer-logo-white.png"  height="68" width="230" alt="Logo">
      <img v-else-if="getApplicantType === 'Realshield'" src="../../../public/assets/images/realshield-logo-blue.png"  height="68" width="230" alt="Logo">
      <img v-else src="../../../public/assets/images/orep-white-logo.png"  height="68" width="230" alt="Logo">
    </div>
    <div class="input-section">
      <div class="mb-4">      
        <div class="row justify-content-between align-items-center">
          <h4 v-if="getApplicantType === 'Mercer'" class="col-md-8">
            Thank you for submitting your application to OREP, we will review your application and send your Quote within two to three (2-3) business days.
            If you have any questions, please email <a target="_blank" href="mailto:mercer.service@mercer.com" style="font-size: 20px; color: #3d85c6;">mercer.service@mercer.com</a>
            or call <strong>800-621-2351</strong>.
          </h4>
          <h4 v-else-if="getApplicantType === 'Realshield'" class="col-md-8">
            Thank you for submitting your application to OREP, we will review your application and send your Quote within two to three (2-3) business days.
            If you have any questions, please email <a target="_blank" href="mailto:mercer.service@mercer.com" style="font-size: 20px; color: #3d85c6;">mercer.service@mercer.com</a>
            or call <strong>800-621-2351</strong>.
          </h4>

          <h4 v-else class="col-md-8">
            Thank you for submitting your application to OREP, we will review your application and send your Quote within two to three (2-3) business days.
            If you have any questions, please email <a target="_blank" href="mailto:info@orep.org" style="font-size: 20px; color: #3d85c6;">info@orep.org</a>
            or call <strong>888-347-5273</strong>.
          </h4>
          <div class="col-md-4">
            <img v-if="getApplicantType === 'Mercer'" src="../../../public/assets/images/standard-mercer-call.png" class="img-call" style="width:225px" alt="Logo">
            <img v-else-if="getApplicantType === 'Realshield'" src="../../../public/assets/images/call.png" class="img-call" style="width:225px" alt="Logo">
            <img v-else src="../../../public/assets/images/call.png" class="img-call" style="width:225px" alt="Logo">
          </div>        
        </div>
      </div>
      <div class="mb-4 program-highlight">
        <h4>Program Highlights</h4>
        <ul>
          <li>Broad Coverage for Appraisers: Coverage for Residential, Commercial, Right of Way Appraisals</li>
          <li>Inexpensive Option to Add Trainee Coverage</li>
          <li>$25,000 Subpoena Assistance</li>
          <li>Loss of Earning: $500 a day, $10,000 maximum.</li>
          <li>AMC Extension Coverage Available</li>
          <li>FREE extended reporting period in case of disability/death</li>
          <li>FREE extended reporting period upon retirement (if an OREP policyholder for 5 years)</li>
          <li>OREP Serving Real Estate Professionals E&O Insurance Needs over 20 Years</li>
        </ul>
        <p class="strong mt-4">Why OREP</p>
        <ul>
          <li>14 Hours FREE CE for Appraisers (most states)</li>
          <li>Free State Board Complaint Consulting</li>
          <li>Free Risk Management and Claims Support</li>
          <li>Guaranteed Delivery of Working RE Magazine</li>
        </ul>
      </div>

      <div v-if="getApplicantType === 'Mercer'" class="mb-4 footer">
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            AMBA
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            PO Box 4050 NW 114th Street, Bldg 19
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Urbandale, IA  50322
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            1-866-795-9613
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            amba.service@amba.info
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits Advisors, LLC. In CA d/b/a
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits & Insurance Agency
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            CA Insurance License #0I96562
          </p>
        </div>
      </div>

      <div v-else-if="getApplicantType === 'Realshield'" class="mb-4 footer">
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            6353 El Cajon Blvd, Suite 124-605
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            San Diego, CA 92115
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (888) 347-5273
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            inspectors@OREP.org
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP Insurance Services, LLC. Calif. Lic. #0K99465
          </p>
        </div>
      </div>

      <div  v-else class="mb-4 footer">
        <p class="mt-3 strong">OREP</p>
        <p>6353 El Cajon Blvd, Suite 124-605</p>
        <p>San Diego, CA 92115 </p>
        <p>(888) 347-5273</p>
        <p>inspectors@OREP.org</p>
        <p>OREP Insurance Services, LLC. Calif. Lic. #0K99465</p>
      </div>
    </div>
    


  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: "standard-application-representation",
    computed: {
      standardApplication() {
        return this.$store.state.standardApplication.standardApplication;
      },
      state() {
        return this.$store.state.standardApplication;
      },
      errorMsg() {
        return this.$store.state.standardApplication.errorMsg;
      },
      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/standard-application-amba/' || this.standardApplication.customer.partnerName === 'Mercer'){
          return 'Mercer';
        }else if (first === '/portal/standard-application-realshield/' || this.standardApplication.customer.partnerName === 'Realshield'){
          return 'Realshield';
        }else {
          return 'OREP';
        }
      },
    },

    mounted() {
      $('html, body').animate({
          scrollTop: $('.presentation-container').offset().top
      }, 500);
    },
  }
</script>

<style scoped>
  .container {
    background-color: white !important;
    padding-bottom: 30px;
  }
  .img-call {
    height: 170px;
    max-height: 170px;
  }
  p {
    margin: 5px 0;
  }
  .strong {
      font-weight: bold !important;
  }
  table td {
    padding: 0 5px !important;
  }
  table > tbody > tr > td:first-child {
    width: 35%
  }
  table > tbody > tr > td:last-child {
    width: 65%
  }


  .table-bordered td {
    vertical-align: top;
    border-right: 2px solid #dee2e6;
    border-left-width: 0;
    border-bottom-width: 0;
    border-top-width: 0;
  }
</style>
